import { render, staticRenderFns } from "./activity-details.vue?vue&type=template&id=243da192"
import script from "./activity-details.vue?vue&type=script&lang=js"
export * from "./activity-details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports